import { just, Maybe, nothing } from 'maybeasy';
import { error } from '../../../../ErrorHandling';
import { ProductLicensesResource } from '../../Types';
import { TPlainTextKey } from '../../../../Translations';
import { action, computed, makeObservable, observable } from 'mobx';
import { ProductLicensesState, loading, ready, waiting } from './Types';
import { errorAlert, FlashAlert } from '../../../../Notifications/Types';

class ProductLicensesStore {
  @observable state: ProductLicensesState = waiting();

  constructor() {
    makeObservable(this);
  }

  @action
  loading = () => {
    switch (this.state.kind) {
      case 'error':
      case 'loading':
      case 'ready':
        break;
      case 'waiting':
        this.state = loading();
        break;
    }
  };

  @action
  ready = (productLicensesResource: ProductLicensesResource) => {
    switch (this.state.kind) {
      case 'waiting':
      case 'ready':
      case 'error':
        break;
      case 'loading':
        this.state = ready(productLicensesResource);
        break;
    }
  };

  @computed
  get productLicensesResource(): Maybe<ProductLicensesResource> {
    switch (this.state.kind) {
      case 'waiting':
      case 'loading':
      case 'error':
        return nothing();
      case 'ready':
        return just(this.state.productLicensesResource);
    }
  }

  @action
  error = (msg: TPlainTextKey) => {
    switch (this.state.kind) {
      case 'waiting':
      case 'ready':
      case 'error':
        break;
      case 'loading':
        this.state = error(msg);
        break;
    }
  };

  @computed
  get notification(): Maybe<FlashAlert> {
    switch (this.state.kind) {
      case 'waiting':
      case 'loading':
      case 'ready':
        return nothing();
      case 'error':
        return just(this.state).map(errorAlert);
    }
  }
}

export default ProductLicensesStore;
